module.exports = __webpack_public_path__ + "img/ring.112afc2d.gif";